module.exports = __webpack_public_path__ + "static/media/storeIcon.ada5618d.svg";